












































































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { ProductionTime, ProductionTimeOption } from '@/models/entities/ProductionTime';
import { DropdownFilter } from '@/models/filters/Filters';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';
import { Category } from '@/models/entities/Category';
import ProductionTimeOptionsBlock from '@/components/entities/productionTimes/ProductionTimeOptionsBlock.vue';

interface Props {
  id: string;
}

interface State {
  entity: ProductionTime;
  loading: boolean;
}

const Component = defineComponent({
  name: 'ProductionTimeDialog',

  components: {
    EntityDialog,
    PaginatedAutocomplete,
    ProductionTimeOptionsBlock,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let productionTime = new ProductionTime({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(`productionTimesModule/fetchItem`, props.id);
        if (!res) $router.back();
      }
    });

    const categoryFilterDropdown = new DropdownFilter({
      label: 'Category',
      itemsModuleName: 'categoriesModule',
      initialValue: undefined,
    });

    const state = reactive({
      entity: productionTime,
      loading: computed(() => $store.getters['productionTimesModule/loading']),
    }) as State;

    watch(
      () => $store.getters['productionTimesModule/selectedItem'],
      (newValue: ProductionTime) => {
        Object.assign(productionTime, newValue);
        categoryFilterDropdown.initialValue = productionTime.categories
          ? productionTime.categories.map(cat => cat.id)
          : [];
      },
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Production Time';
      return `Edit Production Time`;
    });

    function editCategories(newValue: (Category | number)[]) {
      const newCategories: Category[] = [];
      newValue.forEach(category => {
        if (typeof category === 'number') {
          const old = state.entity.categories.find(item => item.id === category);
          if (old) newCategories.push(old);
        } else {
          newCategories.push(category);
        }
      });
      state.entity.categories = newCategories;
    }

    function deleteOption(option: ProductionTimeOption) {
      let index;
      if (option.id !== 0)
        index = state.entity.options.findIndex(item => item.id === option.id);
      else
        index = state.entity.options.findIndex(
          item =>
            item.name === option.name &&
            item.pricePerPair === item.pricePerPair &&
            item.withLogo === item.withLogo,
        );

      state.entity.options.splice(index, 1);
    }

    function addOption(option: ProductionTimeOption) {
      state.entity.options.push(option);
    }

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
      category: [(v: Category[]) => v.length > 0 || 'Category is required'],
    };

    return {
      state,
      title,
      rules,
      isNew,
      categoryFilterDropdown,
      editCategories,
      deleteOption,
      addOption,
    };
  },
});
export default Component;
